<script>
    import Popup from './popup.svelte';

    let border;
    let backDiv;
    let innertext;
    let edit = false;
    let underButtonText;
    let mainDivWidth;

    export let state = 'temp';
    export let seatClr = 'white';
    export let number = '100';
    export let textClrHover = 'white';
    export let textClr = 'white';
    export let numberClr = 'white';
    export let fontSize = '1.111vh';
    export let borderClr = '#F7FFC8';
    export let borderClrHover = 'black';
    export let backgroundColorHover = 'black';
    export let backgroundColor = 'transparent';
    export let btnTitle = 'Join Storytellers Governace Council';
    /**
     */
    function hover() {
        backDiv.style.backgroundColor = backgroundColorHover;
        mainDivWidth.style.borderColor = 'transparent';
        border.style.borderColor = borderClrHover;
        underButtonText.style.opacity = '100%';
        innertext.style.color = textClrHover;
        mainDivWidth.style.width = backDiv;
        backDiv.style.width = '103%';
        setTimeout(Weight, 500);
    }
    /**
     */
    function hoverout() {
        backDiv.style.backgroundColor = backgroundColor;
        border.style.borderColor = borderClr;
        underButtonText.style.opacity = '0%';
        innertext.style.fontWeight = 700;
        innertext.style.color = textClr;
        backDiv.style.width = '0%';
    }
    /**
     */
    function Weight() {
        mainDivWidth.style.borderColor = backDiv;
        innertext.style.fontWeight = 900;
        backDiv.style.width = '100%';
    }
</script>

<section
    style="
    --border-color:{borderClr}; 
    --font-color:{textClr}; 
    --background-Color:{backgroundColor}; 
    --numberClr:{numberClr}; 
    --seatClr:{seatClr}; 
    --fontSize:{fontSize}; 
    --mainDivWidth:{mainDivWidth}"
    role="presentation"
    on:click={() => {
        edit = true;
    }}
    bind:this={mainDivWidth}
>
    <div
        class="main-div"
        bind:this={border}
        on:mouseenter={hover}
        on:mouseleave={hoverout}
    >
        <p bind:this={innertext}>{btnTitle}</p>
        <div class="backdiv" bind:this={backDiv} />
    </div>
    <p class="underText" bind:this={underButtonText}>
        <span>{number}</span> seats remaining
    </p>
</section>

{#if edit}
    <Popup
        JoinAs={state}
        on:click={() => {
            edit = false;
        }}
    />
{/if}

<style>
    p {
        margin: 0;
    }
    section {
        font-style: normal;
        position: relative;
        font-family: "Orbitron";
        width: var(--mainDivWidth);
    }
    .main-div {
        /* width: 100%; */
        width: var(--mainDivWidth);
        height: 100%;
        display: flex;
        /* overflow: hidden; */
        /* overflow-y: hidden; */
        cursor: pointer;
        position: relative;
        padding: 0.5vw 0vw;
        align-items: center;
        border-style: solid;
        border-width: 0.052vw;
        align-content: center;
        flex-direction: column;
        box-sizing: border-box;
        transition-duration: 0.5s;
        justify-content: space-between;
        border-color: var(--border-color);
    }
    .backdiv {
        position: absolute;
        z-index: 0;
        height: 100%;
        width: 0%;
        top: -0.1vh;
        transition-duration: 0.5s;
        background-color: var(--background-Color);
        border-style: solid;
        border-width: 0.052vw;
        border-color: transparent;
    }
    .main-div p {
        color: var(--font-color);
        font-size: var(--fontSize);
        position: relative;
        font-weight: 700;
        z-index: 1;
    }
    .underText {
        opacity: 0%;
        font-weight: 700;
        text-align: center;
        line-height: 1.8vw;
        font-size: 0.926vh;
        color: var(--seatClr);
        letter-spacing: 0.02em;
    }
    .underText span {
        font-size: 1.481vh;
        color: var(--numberClr);
    }
</style>
